<div class="msg">
  <span class="info-title">{{data?.title + ':'}}</span>
  <p class="msg-text">{{data?.content}}</p>
  <div class="pos-btn">
    <button class="btn" (click)="close()">Ok</button>
  </div>
</div>